<template>
  <div class="app-container">
    <div id="app1">
      <div class="content">
        <div class="detail">
          <div class="box">
            <span class="label">客户名称：</span>
            <div class="text">{{ cname }}</div>
          </div>
          <div class="box">
            <span class="label">门店名称：</span>
            <div class="text">{{ shopName }}</div>
          </div>
          <div class="box">
            <span class="label">SIP用户认证ID：</span>
            <div class="text">{{ nvrId }}</div>
          </div>
          <div class="box">
            <span class="label">NVR状态：</span>
            <div class="text">{{ formatLabel(runningStatusList, parseInt(status)) || '--' }}</div>
          </div>
        </div>
        <div class="title">
          已绑定摄像头
        </div>

        <el-table :data="bindTablePageData"
                  class="bindtable"
                  v-loading="bindLoading"
                  show-overflow-tooltip
        >
          <el-table-column
            prop="channelName"
            label="设备名称"
            width="100"
            show-overflow-tooltip
          />
          <el-table-column
            prop="channelId"
            label="通道ID"
            show-overflow-tooltip
          />
          <el-table-column
            prop="cameraId"
            label="cameraid"
            show-overflow-tooltip
          />
          <el-table-column
            prop="snapshot"
            label="快照"
          >
            <template slot-scope="scope">
              <el-image
                :src="scope.row.snapshot"
                :preview-src-list="[scope.row.snapshot]"
                style="width: 50px; height: 50px"
                />
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
          >
            <template slot-scope="scope">
              <status :data="scope.row.status"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="bindTime"
            label="绑定时间"
          />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="toPlayVideo(scope.row)">播放</el-button>
              <el-button type="text" @click="unbind(scope.row)">解绑</el-button>
            </template>

          </el-table-column>
        </el-table>
        <local-pagination
          :list="bindTableData"
          v-model="bindTablePageData"
        />
        <el-button class="newDevice" type="primary" @click="getUnbindCameras">扫描新的设备</el-button>

        <el-table :data="unbindTableData" class="unbindtable" v-loading="unbindLoading" show-overflow-tooltip>
          <el-table-column
            prop="channelName"
            label="设备名称"
            width="100"
          />
          <el-table-column
            prop="channelId"
            label="通道ID"
            show-overflow-tooltip
          />
          <el-table-column
            prop="snapshot"
            label="快照"
          >
            <template slot-scope="scope">
              <el-image
                :src="scope.row.snapshot"
                :preview-src-list="[scope.row.snapshot]"
                style="width: 50px; height: 50px"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
          >
            <template slot-scope="scope">
              <status :data="scope.row.status"/>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="toPlayVideo(scope.row)">播放</el-button>
              <el-button type="text" @click="bindCamera(scope.row)">绑定</el-button>
            </template>
          </el-table-column>
        </el-table>
        <local-pagination
          :list="unbindTableData"
          v-model="unbindTablePageData"
        />
        <el-dialog :visible.sync="imgDialog" class="imgDialog" width="800px" title="预览" :before-close="handleClose">
          <img :src="bigImgUrl" class="bigImgUrl" />
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import cameraMixin from './cameraMixin'
import { computedDataRate, formatLabel } from 'src/utils/common'
import { bindCamera4Nvr, getNvrCameraList, hasSPOfNewRetail, unbindCamera4Nvr } from 'src/api/nvr'
import Status from 'src/components/Status'
import { runningStatusList } from 'src/utils/dict'
import LocalPagination from '../../../components/LocalPagination.vue'

export default {
  mixins: [cameraMixin],
  components: { LocalPagination, Status},
  data() {
    return {
      computedDataRate,
      id: '',
      productId: '',
      nvrId: this.$route.query.nvrId,
      cname: this.$route.query.cname,
      shopName: this.$route.query.shopName,
      boxPort: '',
      boxMacId: '',
      boxNo: '',
      bindTableData: [],
      bindTablePageData: [],
      unbindTableData: [],
      unbindTablePageData: [],
      newTable: [],
      multipleSelection: [],
      pkid: '',
      status: this.$route.query.status,
      select: false,
      imgDialog: false,
      bigImgUrl: '',
      currentPage: 1,
      pageSize: 5,
      total: 0,
      wordString: '',
      isIndeterminate: false,
      bindLoading: false,
      unbindLoading: false,
      runningStatusList,
    }
  },
  watch: {
    wordString() {
      this.currentPage = 1
      const arrData = this.newTable.filter(
        (e) => e.macId?.includes(this.wordString) || e.boxMAC?.includes(this.wordString)
      )
      this.total = arrData.length
    },
  },
  computed: {
    nobindtable() {
      return this.newTable
        .filter((e) => e.macId?.includes(this.wordString) || e.boxMAC?.includes(this.wordString))
        .slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
  },
  mounted() {
    this.id = this.$route.query.boxId
    this.productId = this.$route.query.productId
    this.overviewInit()
  },
  methods: {
    formatLabel,
    handleConfirm1Close() {
      this.confirm1Visible = false
      this.confirm1CameraId = ''
    },
    toPlayVideo(row) {
      this.$router.push({
        name: 'nvr-manage-cameraManage-live',
        query: {
          cameraId: row.cameraId,
          nvrId: row.nvrId,
          channelName: row.channelName || '',
          channelId: row.channelId
        }
      })
    },
    async unbindCamera(row) {
      await unbindCamera4Nvr({
        productId: this.productId,
        pkid: this.nvrId,
        channelId: row.channelId,
        cameraid: row.cameraId,
      })
    },
    formatter(row) {
      const obj = {
        VISIBLE_LIGHT: '可见光',
        INFRARED: '红外',
        UNKNOWN: '未知',
      }
      return obj[row.cameraType]
    },
    noindexTable(index) {
      if (typeof index === 'undefined') return
      return index + 1
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    getCameraList() {
      this.getBindCameras()
      this.getUnbindCameras()
    },
    async getBindCameras() {
      this.bindLoading = true
      try {
        const res = await getNvrCameraList({
          productId: this.productId,
          nvrId: this.nvrId,
          bindStatus: 1
        })
        if (res.status === 0) {
          this.bindTableData = res.data
        }
      } finally {
        this.bindLoading = false
      }
    },
    async getUnbindCameras() {
      this.unbindLoading = true
      try {
        const res = await getNvrCameraList({
          productId: this.productId,
          nvrId: this.nvrId,
          bindStatus: 0
        })
        if (res.status === 0) {
          this.unbindTableData = res.data
        }
      } finally {
        this.unbindLoading = false
      }
    },
    async bindCamera(row) {
      // 是否有客流解决方案
      const {data} = await hasSPOfNewRetail({
        shopId: this.$route.query.shopId,
      })
      let cameraId = ''
      if (data) {
        const res = await this.$prompt(<div>
          <div>如果此摄像头已经在新零售客流方案中与盒子绑定, 请输入它对应在新零售客流方案中的cameraID, 否则这里会新生成一个cameraID</div>
        </div>, {
          inputPlaceholder: '非必填',
          cancelButtonText: '关闭',
          confirmButtonText: '确定',
        })
        cameraId = res.value
      }
      if (this.bindTableData.find(e => e.cameraId === cameraId)) {
        this.$message.error('绑定失败! cameraID不能重复输入')
        return
      }
      await bindCamera4Nvr({
        productId: this.productId,
        pkid: this.nvrId,
        channelId: row.channelId,
        cameraid: cameraId,
        // mac: '',
      })
      this.$message.info('绑定成功')
      this.getCameraList()
    },
    rowSelection(rows) {
      rows.forEach((row) => {
        if (row.canBeCheck) {
          this.$refs.multipleTable.toggleRowSelection(row)
        }
      })
    },
    toggleSelection(rows) {
      if (this.multipleSelection.length && this.isIndeterminate) {
        this.$refs.multipleTable.clearSelection()
        setTimeout(() => {
          this.rowSelection(rows)
          this.select = true
        }, 100)
      } else {
        this.rowSelection(rows)
        this.select = this.multipleSelection.length > 0
      }
    },
    handleSelectionChange(val) {
      const avaliTable = this.nobindtable.filter((e) => e.canBeCheck===true)
      //选中一条
      this.multipleSelection = val
      this.isIndeterminate = val.length > 0 && val.length < avaliTable.length
      if (
        this.multipleSelection?.length === avaliTable?.length
      ) {
        console.log(8888,this.multipleSelection,'====',avaliTable)
        this.select = true
      } else {
        this.select = false
      }
    },
    bindBox() {
      if (!this.multipleSelection.length) {
        this.$alert('请先选择要绑定的摄像头', '绑定', {
          confirmButtonText: '确定',
          type: 'warning',
        })
        return
      }
      if (this.bindTableData.length + this.multipleSelection.length > 1000) {
        this.$alert('摄像头绑定数量已达上限', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
        })
        return
      }
      this.$confirm('确定要绑定到该盒子上吗?', '绑定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.bindCamera()
      })
    },
    overviewInit() {
      //页面初始化
      this.getCameraList()
    },
    back() {
      this.$router.go(-1)
    },
    next() {
      this.$router.go(-1)
    },
    change(row) {
      const { path } = this.$route
      const query = {
        cameraId: row.cameraId,
        productId: this.productId,
      }

      if (/^\/productManage/.test(path)) {
        this.$router.push({
          name: this.$route.name + '-update',
          query,
        })
      } else {
        this.$router.push({
          path: '/box/query/change',
          query,
        })
      }
    },
    async unbind(row) {
      await this.$confirm(`是否解绑${row.cameraId}摄像头`, '提示')
      await this.unbindCamera(row)
      await this.getCameraList()
    },
    handleClose(done) {
      done()
    },
    enlargeImg(url) {
      this.imgDialog = true
      this.bigImgUrl = url
    },
    // 跳转到设备信息页
    toDeviceInfo(row) {
      let href = process.env.VUE_APP_DEVICE_APP
      const username = JSON.parse(localStorage.getItem('user'))[0].username
      const accessToken = localStorage.getItem('accessToken')
      window.open(
        href + '?accessToken=' + accessToken + '&cameraId=' + row.cameraId + '&username=' + username + '&boxType=0'
      )
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

* {
  box-sizing: border-box;
}

.containerX .contentX {
  padding-left: 0;
  padding-right: 0;
}

.titletop {
  width: 100%;
  height: 80px;
  line-height: 80px;
  border-bottom: 1px solid #d1d1d1;
  padding: 0px 20px;
}

.titletop span {
  font-size: 14px;
  color: #5c76cc;
}

.titletop span i {
  color: #333;
}

.content {
  padding: 0 20px 40px;
}
.content .detail {
  padding: 10px 0;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #d1d1d1;
  flex-wrap: wrap;
}
.content .detail .box {
  display: flex;
  align-items: center;
  margin-right: 20px;
  margin-bottom: 8px;
}
/* .content .detail div .label{
  float:left;
}
.content .detail  .box:nth-child(1) .text,
.content .detail  .box:nth-child(2) .text
{
  margin-left: 70px;
}
.content .detail  .box:nth-child(3) .text{
  margin-left: 56px;
}
.content .detail  .box:nth-child(4) .text{
  margin-left: 90px;
} */
.content .title {
  font-size: 18px;
  margin-top: 20px;
}

.content .title span {
  color: #5c76cc;
}

.bindtable,
.nobindtable,
.allSelect {
  margin-bottom: 20px;
}
.allSelect {
  display: flex;
  justify-content: space-between;
}
.allSelect .el-checkbox {
  margin-right: 20px;
}

.el-button {
  font-size: 12px;
}

.hideLabel .el-checkbox,
.hideLabel div {
  display: none !important;
}
.newDevice {
  margin-top: 20px;
}
.unbind::before {
  content: '';
  height: 5px;
  border-left: 1px solid @linkColor;
  margin-right: 12px;
}

.screenshot {
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.imgDialog .el-dialog__header {
  padding: 0;
  border: none;
  height: 0px;
}

/* 关闭按钮 */
.imgDialog .el-dialog__headerbtn {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #c2c2c2;
  right: 10px;
  top: 10px;
}

/* 关闭图标 */
.imgDialog .el-dialog__headerbtn .el-icon-close {
  color: #333;
}

.imgDialog .el-dialog__body {
  padding: 0;
}

.imgDialog .bigImgUrl {
  width: 760px;
  height: 600px;
  vertical-align: top;
}
.el-message-box__content {
  padding-left: 36px;
}

.word-string {
  width: 300px;
}
</style>
